import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  paymentRoot: {
    fontFamily: Theme.typography.base.regular,
    color: Theme.palette.gray[750],
    '& .payment-details': {
      padding: 16,
      display: 'flex',
      gap: 16,
      flexFlow: 'row wrap',
      [Theme.breakpoints.up('md')]: {
        gap: 32,
        padding: 24,
      },
      [Theme.breakpoints.up('lg')]: {
        gap: 65,
        flexFlow: 'row',
      },

      '& >div:nth-child(1)': {
        flex: '1 50%',
        [Theme.breakpoints.up('md')]: {
          flex: 'none',
        },
      },

      '& >div:nth-child(1), :nth-child(2)': {
        [Theme.breakpoints.up('md')]: {
          minWidth: '17%',
        },
      },

      '& >div:last-of-type': {
        fontSize: Theme.typography.size[1],
        [Theme.breakpoints.up('lg')]: {
          fontSize: Theme.typography.size[2],
        },
      },
    },
    '& .payment-actions': {
      padding: 16,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
      background: Theme.palette.gray[100],
      gap: 24,
      [Theme.breakpoints.up('md')]: {
        padding: 24,
        flexDirection: 'row',
      },
    },

    '& .label': {
      display: 'block',
      fontFamily: Theme.typography.base.semiBold,
      color: Theme.palette.text.brand,
      fontSize: Theme.typography.size[2],
      paddingBottom: 4,
      [Theme.breakpoints.up('md')]: {
        paddingBottom: 8,
      },
    },
    '& .value': {
      fontFamily: Theme.typography.base.semiBold,
      textTransform: 'capitalize',
    },
  },
}));

export default useStyles;
